import { Btn, Eyebrow, listReset } from '../components/primitives';
import { useOpenPublisherModal } from '../components/publisher-modal';

export const Pricing = () => {
  const openPublisherModal = useOpenPublisherModal();
  return (
  <section
    id="pricing"
    className="qb-section-tight"
    style={{ padding: '120px 40px', borderBottom: '1px solid var(--qb-border-soft)' }}>
    <div style={{ maxWidth: 1180, margin: '0 auto' }}>
      <div style={{ textAlign: 'center', marginBottom: 56 }}>
        <Eyebrow>PRICING</Eyebrow>
        <h2
          className="qb-section-h2"
          style={{
            fontFamily: 'var(--qb-font-display)',
            textTransform: 'uppercase',
            fontSize: 60,
            lineHeight: 0.95,
            letterSpacing: '-0.015em',
            margin: '16px 0 16px',
            textWrap: 'balance',
          }}>
          Free to build. <span style={{ color: 'var(--qb-orange-500)' }}>Pay when you sell.</span>
        </h2>
        <p
          style={{
            fontFamily: 'var(--qb-font-body)',
            fontSize: 17,
            lineHeight: 1.55,
            color: 'var(--qb-fg-muted)',
            margin: '0 auto',
            maxWidth: 580,
          }}>
          The engine is yours forever, no strings. Publishers pay one flat subscription to unlock
          hosting, the storefront, dashboard, and payouts.
        </p>
      </div>

      <div className="qb-pricing-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 28 }}>
        <div
          className="qb-pricing-card"
          style={{
            background: 'var(--qb-ink-800)',
            border: '1px solid var(--qb-border-strong)',
            borderRadius: 6,
            padding: '32px 32px 28px',
            display: 'flex',
            flexDirection: 'column',
          }}>
          <Eyebrow>ENGINE · CORE</Eyebrow>
          <h3
            className="qb-pricing-h3"
            style={{
              fontFamily: 'var(--qb-font-display)',
              textTransform: 'uppercase',
              fontSize: 32,
              lineHeight: 1,
              margin: '12px 0 18px',
            }}>
            Free & open source
          </h3>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 8 }}>
            <span
              className="qb-pricing-price"
              style={{
                fontFamily: 'var(--qb-font-display)',
                fontSize: 56,
                lineHeight: 1,
                letterSpacing: '-0.02em',
              }}>
              $0
            </span>
            <span
              style={{
                fontFamily: 'var(--qb-font-body)',
                fontSize: 14,
                color: 'var(--qb-fg-muted)',
              }}>
              forever
            </span>
          </div>
          <p
            style={{
              fontFamily: 'var(--qb-font-body)',
              fontSize: 14,
              lineHeight: 1.6,
              color: 'var(--qb-fg-muted)',
              margin: '0 0 22px',
              maxWidth: 380,
            }}>
            The whole engine, on your machine. Build any Ruleset for personal use. Run it at your
            table, share it with your friends, fork it on GitHub.
          </p>
          <ul
            style={{
              ...listReset,
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              marginBottom: 26,
            }}>
            {[
              'Full Ruleset & Page Editor',
              'QBScript rules engine',
              'Character sheets, charts, modules',
              'Local & browser play, offline-ready',
              'Open source code on GitHub',
            ].map((s) => (
              <li
                key={s}
                style={{
                  display: 'flex',
                  gap: 10,
                  alignItems: 'baseline',
                  fontFamily: 'var(--qb-font-body)',
                  fontSize: 14,
                  color: 'var(--qb-fg)',
                }}>
                <span
                  style={{
                    color: 'var(--qb-orange-500)',
                    fontFamily: 'var(--qb-font-display)',
                    fontSize: 12,
                  }}>
                  +
                </span>
                {s}
              </li>
            ))}
          </ul>
          <Btn
            kind="secondary"
            size="lg"
            href="https://app.questbound.com"
            style={{ alignSelf: 'flex-start', marginTop: 'auto' }}>
            Start Building — Free
          </Btn>
        </div>

        <div
          className="qb-pricing-card"
          style={{
            background: 'var(--qb-cream-50)',
            color: 'var(--qb-ink-800)',
            border: '3px solid var(--qb-ink-900)',
            boxShadow: 'var(--qb-shadow-stamp)',
            padding: '32px 32px 28px',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
          }}>
          <span
            style={{
              position: 'absolute',
              top: -14,
              right: 22,
              background: 'var(--qb-orange-500)',
              color: '#fff',
              fontFamily: 'var(--qb-font-display)',
              fontSize: 11,
              letterSpacing: '0.16em',
              padding: '6px 12px',
              border: '2px solid var(--qb-ink-900)',
              textTransform: 'uppercase',
            }}>
            FOR CREATORS WHO SELL
          </span>
          <div
            style={{
              fontFamily: 'var(--qb-font-display)',
              fontSize: 11,
              letterSpacing: '0.16em',
              textTransform: 'uppercase',
              color: 'var(--qb-orange-700)',
            }}>
            PUBLISHER PROGRAM
          </div>
          <h3
            className="qb-pricing-h3"
            style={{
              fontFamily: 'var(--qb-font-display)',
              textTransform: 'uppercase',
              fontSize: 32,
              lineHeight: 1,
              margin: '12px 0 18px',
              color: 'var(--qb-ink-800)',
            }}>
            Sell your game
          </h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 8 }}>
            <span
              className="qb-pricing-price-text"
              style={{
                fontFamily: 'var(--qb-font-display)',
                textTransform: 'uppercase',
                fontSize: 36,
                lineHeight: 1,
                letterSpacing: '-0.01em',
                color: 'var(--qb-ink-800)',
              }}>
              Free Hosting while in Beta
            </span>
            <span style={{ fontFamily: 'var(--qb-font-body)', fontSize: 14, color: '#42403e' }}>
              15% per sale
            </span>
          </div>
          <p
            style={{
              fontFamily: 'var(--qb-font-body)',
              fontSize: 14,
              lineHeight: 1.6,
              color: '#42403e',
              margin: '0 0 22px',
              maxWidth: 380,
            }}>
            Everything in Engine, plus the storefront, the dashboard, payouts, and customer
            accounts. Cancel anytime — your Rulesets are yours.
          </p>
          <ul
            style={{
              ...listReset,
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              marginBottom: 26,
            }}>
            {[
              'Custom storefront on questbound.com',
              'Stripe payouts, direct to your bank',
              'Sales + activity dashboard',
              'Host on your-game.questbound.com',
              'Discount codes, gifting, refunds',
              'Priority Discord channel & support',
            ].map((s) => (
              <li
                key={s}
                style={{
                  display: 'flex',
                  gap: 10,
                  alignItems: 'baseline',
                  fontFamily: 'var(--qb-font-body)',
                  fontSize: 14,
                  color: 'var(--qb-ink-800)',
                }}>
                <span
                  style={{
                    color: 'var(--qb-orange-700)',
                    fontFamily: 'var(--qb-font-display)',
                    fontSize: 12,
                  }}>
                  +
                </span>
                {s}
              </li>
            ))}
          </ul>
          <Btn
            kind="primary"
            size="lg"
            href="#"
            onClick={openPublisherModal}
            style={{ alignSelf: 'flex-start', marginTop: 'auto' }}>
            Become a Publisher →
          </Btn>
        </div>
      </div>

      <p
        style={{
          textAlign: 'center',
          marginTop: 28,
          fontFamily: 'var(--qb-font-body)',
          fontStyle: 'italic',
          fontSize: 13,
          color: 'var(--qb-fg-subtle)',
        }}>
        The engine stays free and open source — that's not changing. The Publisher Program is for
        creators who want a storefront and the platform infra to run a business on top of it.
      </p>
    </div>
  </section>
  );
};
